<template>
    <div>
        <el-row :style="sousuo? '':'margin-bottom: 20px;'">
            <el-col :span="2" >
                <el-button :size="size1" v-permission="['SYS-LOG-LOGIN-REMOVE','SYS-OPER-LOG-DELETE']" :disabled="multiple" type="primary" icon="el-icon-delete" @click="deleteDialog('')">批量删除</el-button>
            </el-col>
            <el-col :span="2" >
                <el-button v-if="sousuo" :size="size1" v-permission="['SYS-LOG-OPERATE-PAGE']" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            </el-col>
        </el-row>
        <el-row v-if="sousuo" :gutter="20"  style="margin-top: 20px;">
            <el-form :model="queryInfo" ref="queryForm" :size="size1" label-width="100px">
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="业务操作类型" prop="type">
                            <el-select :size="size1" v-model="queryInfo.businessType" placeholder="业务操作类型" clearable>
                                <el-option
                                        v-for="item in businessTypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="操作时间">
                            <el-date-picker
                                    v-model="dateRange"
                                    value-format="yyyy-MM-dd"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="标题" prop="">
                            <el-input :size="size1" placeholder="请输入标题" v-model="queryInfo.title" clearable ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="用户名" prop="">
                            <el-input :size="size1" placeholder="请输入用户名" v-model="queryInfo.operName" clearable ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="手机号" prop="">
                            <el-input :size="size1" placeholder="请输入手机号" v-model="queryInfo.mobile" clearable ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="ip地址" prop="">
                            <el-input :size="size1" placeholder="请输入ip地址" v-model="queryInfo.operIp" clearable ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="部门" prop="">
                            <el-input :size="size1" placeholder="请输入部门" v-model="queryInfo.deptName" clearable ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="接口" prop="">
                            <el-input :size="size1" placeholder="请输入地址" v-model="queryInfo.operUrl" clearable ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-row>
        <!--列表展示style="margin-top: 20px;"-->
        <el-row >
            <el-table v-loading="loading" ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist" @selection-change="handleSelectionChange">
                <template v-for="(v,k) in columns">
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.label==='操作'">
                        <template slot-scope="scope">
                            <el-button v-permission="['SYS-OPER-LOG-DETAIL']" v-if="xiangqing" type="info" icon="el-icon-message" size="mini" round @click="showDialog(scope.row)">详情</el-button>
                            <el-button type="danger" icon="el-icon-delete" size="mini" round @click="deleteDialog(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='status'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status" style="color:red;">失败</span>
                            <span v-else style="color:green;">成功</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='operatorType'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.operatorType===0" style="color:red;">其他</span>
                            <span v-if="scope.row.operatorType===1" style="color:green;">1</span>
                            <span v-if="scope.row.operatorType===2" style="color:blue;">2</span>
                        </template>
                    </el-table-column>
                    <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                </template>
            </el-table>
            <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        </el-row>
        <el-dialog title="操作详情"
            :visible.sync="dialogVisible"
           :close-on-click-modal="false"
           :close-on-press-escape="false"
           :destroy-on-close="true"
            width="80%"
            @close="handleCloseInfo">
            <el-card shadow="hover" class="el-card" >
                <el-descriptions class="margin-top" title="" :column="2" :size="size">
                    <el-descriptions-item label="businessType">{{form.businessType}}</el-descriptions-item>
                    <el-descriptions-item label="部门">{{form.deptName}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions class="margin-top" title="" :column="2" :size="size">
                    <el-descriptions-item label="操作用户">{{form.operName}}</el-descriptions-item>
                    <el-descriptions-item label="手机号">{{form.mobile}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions class="margin-top" title="" :column="2" :size="size">
                    <el-descriptions-item label="操作Ip">{{form.operIp}}</el-descriptions-item>
                    <el-descriptions-item label="操作地址">{{form.operLocation}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions class="margin-top" title="" :column="2" :size="size">
                    <el-descriptions-item label="标题">{{form.title}}</el-descriptions-item>
                    <el-descriptions-item label="参数">{{form.operParam}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions class="margin-top" title="" :column="2" :size="size">
                    <el-descriptions-item label="方法">{{form.method}}</el-descriptions-item>
                    <el-descriptions-item label="接口">{{form.operUrl}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions class="margin-top" title="" :column="2" :size="size">
                    <el-descriptions-item label="请求时间">{{form.operTime}}</el-descriptions-item>
                    <el-descriptions-item label="请求方式">{{form.requestMethod}}</el-descriptions-item>
                    <el-descriptions-item label="请求时长">{{form.totalTime}}</el-descriptions-item>
                    <el-descriptions-item label="请求状态">
                        <span v-if="form.status" style="color: red;">失败</span>
                        <span v-else style="color: green;">成功</span>
                    </el-descriptions-item>
                </el-descriptions>
                <el-descriptions class="margin-top" title="" :column="1" :size="size">
                    <el-descriptions-item label="错误信息" >{{form.errorMsg}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions class="margin-top" title="" :column="1" :size="size">
                    <el-descriptions-item label="返回结果" :contentStyle="{'max-height':'100px','overflow-y': 'scroll'}">{{form.jsonResult}}</el-descriptions-item>
                </el-descriptions>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from '@/components/pagination/index'
    import {dictDataList} from '@/api/dict'

    export default {
        name: '',
        components: {
            Pagination
        },
        props: {
            columns: {
                type: Array,
                default:function () {
                    return []
                }
            },
            xiangqing:{
                type:Boolean,
                default: false
            },
            sousuo:{
                type:Boolean,
                default: false
            }
        },
        data() {
            return {
                tablelist: [],
                total:0,
                treeTableHeight: 650,
                queryInfo: {
                    pagesize: 10,
                    pagenum: 1,
                    state: null,
                    repairType: null,
                    keyCode: null,
                    userNameAn: null
                },
                dialogVisible:false,
                form: {
                    status:true,
                    remark:'',
                    id:''
                },
                checkedList:[],
                multiple: true,
                size:'',
                size1:this.COMMON.size,
                businessTypeList:[],
                dateRange: [],
                loading: true
            }
        },
        methods: {
            getHeight() {
                if(this.sousuo){
                    this.treeTableHeight = window.innerHeight - 60 - 40 - 55 -60 -102 - 32 + 'px'
                }else{
                    this.treeTableHeight = window.innerHeight - 60 - 40 - 55 -60 - 32 + 'px'
                }
            },
            init() {
                if(this.dateRange!=null && this.dateRange.length>0){
                    this.queryInfo.beginTime = this.dateRange[0]
                    this.queryInfo.endTime = this.dateRange[1]
                }else{
                    this.queryInfo.beginTime = null
                    this.queryInfo.endTime = null
                }
                let param = {}
                param.current = this.queryInfo.pagenum
                param.size = this.queryInfo.pagesize
                this.loading = true
                this.$emit('getData',param, this.queryInfo,this)
            },
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize
                this.init()
            },
            /**
             * 分页组件切换页事件处理
             * @param newPage
             */
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage
                this.init()
            },
            showDialog(item){
                console.log('详情项',item)
                this.$emit('showData',item,this)
            },
            async deleteDialog(item){
                const confirmResult = await this.$confirm('此操作将删除该记录信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).catch(err => err)
                // 如果用户确认删除，则返回值未字符串 confirm
                // 如果用户取消了删除，则返回值未字符串 cancel
                if (confirmResult !== 'confirm') {
                    return this.$message.info('取消删除')
                }
                console.log('执行deletaOpe')
                this.$emit('deleteOpe',item,this)
            },
            handleSelectionChange(val) {
                this.checkedList = val
                console.log(this.checkedList)
                this.multiple = !val.length
            },
            handleCloseInfo() {
                this.dialogVisible = false
            },
            getBusinessTypeList(){
                /*let param = {}
                param.current = 1
                param.size = 100*/
                let data={type: 'business_type'}
                dictDataList(data).then(response => {
                    if (response.code != 200)
                        return this.$message.error('获取业务类型失败！')
                    this.businessTypeList = response.data //.records
                    console.log('业务类型数据', this.businessTypeList)
                })
            },
            /** 搜索按钮操作 */
            handleQuery() {
                this.queryInfo.pagenum=1
                this.init()
            }
        },
        created(){
            this.getHeight()
            window.addEventListener('resize', this.getHeight)
            this.init()
            this.getBusinessTypeList()
        },
        activated(){
            this.$refs.tableRef.doLayout()
        }
    }
</script>

<style scoped>

</style>
